import { observe } from 'helpers/dom-helper';

/**
 * Initializes the bootstrap popover component when element is connected to the DOM and disposes it when element is
 * removed from the DOM.
 */
observe('[data-toggle="popover"]', {
  connected(element) {
    if ($.isFunction($('[data-toggle="popover"]').popover)) {
      $(element).popover();
    }
  },
  disconnected(element) {
    if ($.isFunction($('[data-toggle="popover"]').popover)) {
      $(element).popover('dispose');
    }
  },
});
